export const refinePowerList = (currentContent, refinementPrompt, onStepUpdate) => {
  return new Promise((resolve, reject) => {
    const url = `${process.env.REACT_APP_ML_API_ENDPOINT}/api/ml/refine-powerlist-stream`
    
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({
        current_content: currentContent,
        refinement_prompt: refinementPrompt
      }),
      credentials: 'include'
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      
      const reader = response.body.getReader()
      const decoder = new TextDecoder()
      let buffer = ''

      const readStream = () => {
        reader.read().then(({ done, value }) => {
          if (done) {
            reject(new Error('Stream ended without complete response'))
            return
          }

          buffer += decoder.decode(value)
          const lines = buffer.split('\n\n')
          
          // Keep incomplete lines in buffer
          buffer = lines.pop() || ''

          lines.forEach(line => {
            if (line.startsWith('data: ')) {
              try {
                const data = JSON.parse(line.slice('data: '.length))
                
                if (data.step !== undefined && onStepUpdate) {
                  onStepUpdate(data)
                } else if (data.status === 'success') {
                  resolve(data)
                } else if (data.status === 'error') {
                  reject(new Error(data.message))
                }
              } catch (error) {
                console.error('Error parsing refinement step:', error)
              }
            }
          })

          readStream()
        }).catch(error => {
          reject(new Error('Error reading stream'))
        })
      }

      readStream()
    })
    .catch(error => {
      reject(error)
    })
  })
}

export const refineRundown = (currentContent, refinementPrompt, onStepUpdate) => {
  return new Promise((resolve, reject) => {
    const url = `${process.env.REACT_APP_ML_API_ENDPOINT}/api/ml/refine-rundown-stream`
    
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({
        current_content: currentContent,
        refinement_prompt: refinementPrompt
      }),
      credentials: 'include'
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      
      const reader = response.body.getReader()
      const decoder = new TextDecoder()
      let buffer = ''

      const readStream = () => {
        reader.read().then(({ done, value }) => {
          if (done) {
            reject(new Error('Stream ended without complete response'))
            return
          }

          buffer += decoder.decode(value)
          const lines = buffer.split('\n\n')
          
          // Keep incomplete lines in buffer
          buffer = lines.pop() || ''

          lines.forEach(line => {
            if (line.startsWith('data: ')) {
              try {
                const data = JSON.parse(line.slice('data: '.length))
                
                if (data.step !== undefined && onStepUpdate) {
                  onStepUpdate(data)
                } else if (data.status === 'success') {
                  resolve(data)
                } else if (data.status === 'error') {
                  reject(new Error(data.message))
                }
              } catch (error) {
                console.error('Error parsing refinement step:', error)
              }
            }
          })

          readStream()
        }).catch(error => {
          reject(new Error('Error reading stream'))
        })
      }

      readStream()
    })
    .catch(error => {
      reject(error)
    })
  })
}

export const refineBlog = (currentContent, refinementPrompt, onStepUpdate) => {
  return new Promise((resolve, reject) => {
    const url = `${process.env.REACT_APP_ML_API_ENDPOINT}/api/ml/refine-blog-stream`
    
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('token')}`
      },
      body: JSON.stringify({
        current_content: currentContent,
        refinement_prompt: refinementPrompt
      }),
      credentials: 'include'
    })
    .then(response => {
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      
      const reader = response.body.getReader()
      const decoder = new TextDecoder()
      let buffer = ''

      const readStream = () => {
        reader.read().then(({ done, value }) => {
          if (done) {
            reject(new Error('Stream ended without complete response'))
            return
          }

          buffer += decoder.decode(value)
          const lines = buffer.split('\n\n')
          
          // Keep incomplete lines in buffer
          buffer = lines.pop() || ''

          lines.forEach(line => {
            if (line.startsWith('data: ')) {
              try {
                const data = JSON.parse(line.slice('data: '.length))
                
                if (data.step !== undefined && onStepUpdate) {
                  onStepUpdate(data)
                } else if (data.status === 'success') {
                  resolve(data)
                } else if (data.status === 'error') {
                  reject(new Error(data.message))
                }
              } catch (error) {
                console.error('Error parsing refinement step:', error)
              }
            }
          })

          readStream()
        }).catch(error => {
          reject(new Error('Error reading stream'))
        })
      }

      readStream()
    })
    .catch(error => {
      reject(error)
    })
  })
}
